<form [formGroup]="persoonFg">
  <div class="row">
    <snelstart-ui-text-form-control formControlName="voorletters"
                                    id="voorletters"
                                    label="Voorletter(s)"
                                    class="col-auto custom-input-125"
                                    (change)="saveForm()"
    >
    </snelstart-ui-text-form-control>
    <snelstart-ui-text-form-control formControlName="tussenvoegsels"
                                    id="tussenvoegsels"
                                    label="Tussenvoegsel(s)"
                                    class="col-auto custom-input-125"
                                    (change)="saveForm()"
    >
    </snelstart-ui-text-form-control>
  </div>

    <snelstart-ui-text-form-control formControlName="achternaam"
                                    id="achternaam"
                                    label="Achternaam"
                                    class="col-auto custom-input-250"
                                    [required]=true
                                    (change)="saveForm()"
    >
    </snelstart-ui-text-form-control>

    <snelstart-ui-date-form-control formControlName="geboortedatum"
                                    id="geboortedatum"
                                    label="Geboortedatum"
                                    placeholder="dd-mm-jjjj"
                                    class="col-auto custom-input-250"
                                    [required]=true
                                    (change)="saveForm()"
    >
    </snelstart-ui-date-form-control>

    <snelstart-ui-bsn-form-control formControlName="bsn"
                                   id="bsn"
                                   label="Burgerservicenummer"
                                   class="col-auto custom-input-250"
                                   [required]=true
                                   (change)="saveForm()"
    >
    </snelstart-ui-bsn-form-control>
</form>
